module.exports = __webpack_public_path__ + "img/h12.53699444.jpg";